import styled from 'styled-components';
import Checkbox from 'components/checkbox/Checkbox';
import { AvatarLetter } from 'components/avatar';
import { Team } from 'contexts/teams/types';
import { colors } from 'constants/styles/colors';

const SuggestionContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid ${colors.body.bg};
  gap: 15px;

  > .ant-checkbox-wrapper {
    margin-right: 0;
  }

  > .ant-checkbox-wrapper > .ant-checkbox {
    margin-right: 0;
  }

  > .ant-checkbox-wrapper > span:not(.ant-checkbox) {
    padding: 0;
    margin: 0;
  }

  > .team-data {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  h4 {
    margin: 0;
    color: ${colors.fonts.dark};
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: var(--font-family-base);
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
  }

  p {
    margin: 0;
    color: ${colors.fonts.darkGray};
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: var(--font-family-base);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
`;

interface TeamSuggestionItemProps {
  team: Team;
  checked: boolean;
  onCheck: (team: Team) => void;
  disabled?: boolean;
}

const TeamSuggestionItem = ({
  team,
  checked,
  onCheck,
  disabled,
}: TeamSuggestionItemProps): JSX.Element => {
  const teamId = team.id || team.slug || team.name;
  const teamUsersCount =
    typeof team.active_users_count === 'number'
      ? team.active_users_count
      : typeof team.active_users === 'number'
      ? team.active_users
      : 0;

  const teamUsersLabel = teamUsersCount === 1 ? 'user' : 'users';

  return (
    <SuggestionContainer>
      <Checkbox
        id={`team-${teamId}`}
        name={`team-${teamId}`}
        onChange={() => onCheck(team)}
        checked={checked}
        controlled
        disabled={disabled}
      />
      <AvatarLetter name={team.name} rounded={false} size="sm" />
      <div className="team-data">
        <h4>{team.name}</h4>
        <p>
          {teamUsersCount} {teamUsersLabel}
        </p>
      </div>
    </SuggestionContainer>
  );
};

export default TeamSuggestionItem;
